import { Component } from '@angular/core';
import { FormConfig, CustomFormAccessor } from '../form-cva.component';
import { FieldWorkerUnavailableDay } from 'src/shared/api';
import { Validators, NgControl, FormBuilder } from '@angular/forms';
import { CustomValidators } from 'src/shared/validators/custom-validators';
import { takeUntil } from 'rxjs/operators';

export const unavailableDayFormConfig: FormConfig<FieldWorkerUnavailableDay> = {
	id: [''],
	date: ['', [Validators.required, CustomValidators.isNotBeforeToday]],
	reason: [''],
	fieldWorker: [''],
};

@Component({
	selector: 'rpshared-unavailable-day',
	templateUrl: './unavailable-day.component.html',
})
export class UnavailableDayComponent extends CustomFormAccessor<
	FieldWorkerUnavailableDay
> {
	constructor(public ngControl: NgControl, public fb: FormBuilder) {
		super(ngControl, fb, unavailableDayFormConfig);
	}

	// model --> view
	writeValue(value: FieldWorkerUnavailableDay): void {
		super.writeValue(value);
	}

	// view --> model
	registerOnChange(fn: (value: FieldWorkerUnavailableDay) => void) {
		this.form.valueChanges.pipe(takeUntil(this.destroyed)).subscribe(fn);
	}
}
